import {ComponentType, forwardRef, PropsWithChildren} from 'react';
import {DialogContent} from '@shortsworks/ui/components/ui/dialog';
import {ModalProps} from '@shortsworks/ui/components/modal';

interface ModalContentProps extends PropsWithChildren {
  className?: string;
}

export const ModalContent = ({children, className}: ModalContentProps) => {
  return (
    <DialogContent className={className}>
      { children }
    </DialogContent>
  );
};

export function createModalComponent<T, R>(Component: ComponentType<T>) {
  return forwardRef<any, ModalProps<T, R>>(({ close, ...props }, ref) => (
    <Component close={(value?: R) => close({ value: value as R })} {...props as T} />
  ));
}
